export default __webpack_public_path__ + "static/media/Merge1.b44a5fb7.png";